export default __webpack_public_path__ + "static/media/icon-star-feedback.b57ecc11.svg";